import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import UploadPage from './pages/UploadPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SharedGalleryPage from './pages/SharedGalleryPage';
import SettingsPage from './pages/SettingsPage';
import './styles/global.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public shared gallery — no Navbar/Footer, full-screen */}
          <Route path="/s/:token" element={<SharedGalleryPage />} />

          {/* All other routes: Navbar + content + Footer */}
          <Route path="/*" element={
            <div className="main-content">
              <Navbar />
              <div className="main-body">
                <Routes>
                  <Route path="/" element={<Navigate to="/events" replace />} />
                  <Route path="/events" element={
                    <PrivateRoute><EventsPage /></PrivateRoute>
                  } />
                  <Route path="/events/:eventId" element={
                    <PrivateRoute><EventDetailPage /></PrivateRoute>
                  } />
                  <Route path="/upload" element={
                    <PrivateRoute><UploadPage /></PrivateRoute>
                  } />
                  <Route path="/settings" element={
                    <PrivateRoute><SettingsPage /></PrivateRoute>
                  } />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="*" element={<Navigate to="/events" replace />} />
                </Routes>
              </div>
              <Footer />
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
